var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsField',_vm._b({staticClass:"details-raw-data"},'DetailsField',_vm.$attrs,false),[_c('code',[_vm._v(" "+_vm._s(_vm.dataAsString)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }